import { tVariants } from '../../style-system';

const disclosureStyles = tVariants({
    base: 'group/toggle p-1 rounded-md hover:bg-surface-selected transition-colors max-h-max',
    slots: {
        toggleIcon:
            'w-4 h-4 aspect-square text-content-deselected transition-transform duration-200 group-data-open/toggle:rotate-180',
    },
});

export { disclosureStyles };
